var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { faSignalStream } from '@fortawesome/pro-solid-svg-icons';
import { isWithinInterval, isBefore, format } from 'date-fns';
import { Card, ImageContainer, CardContent, Location, DateContainer, EventTitle, EventStatusContainer, Organization, EventStatus } from './style';
import Tooltip from '../Tooltip';
import Highlighter from '../Highlighter';
import { EventDuration, LockTag } from '../style';
var EventCard = function (_a) {
    var bannerUrl = _a.bannerUrl, name = _a.name, startDate = _a.startDate, endDate = _a.endDate, embargoed = _a.embargoed, organizationName = _a.organizationName, location = _a.location, nameHighlightingInformation = _a.nameHighlightingInformation, organizationNameHighlightingInformation = _a.organizationNameHighlightingInformation;
    var titleRef = useRef(null);
    var isBetweenInterval = function () {
        try {
            return isWithinInterval(new Date(), {
                start: new Date(startDate),
                end: new Date(endDate)
            });
        }
        catch (err) {
            return false;
        }
    };
    var getEventStatus = function () {
        if (isBefore(new Date(), new Date(startDate))) {
            return 'upcoming';
        }
        else if (isBetweenInterval()) {
            return 'live';
        }
        return '';
    };
    var getDuration = function () {
        var formattedStartDate = format(new Date(startDate), 'MMM dd, yyyy');
        var formattedEndDate = format(new Date(endDate), 'MMM dd, yyyy');
        return "".concat(formattedStartDate, " - ").concat(formattedEndDate);
    };
    var eventStatus = getEventStatus();
    var duration = getDuration();
    return (_jsxs(Card, { children: [_jsx(ImageContainer, __assign({ bannerUrl: bannerUrl }, { children: _jsxs(EventStatusContainer, __assign({ status: eventStatus }, { children: [eventStatus === 'live' && (_jsx(FontAwesomeIcon, { icon: faSignalStream, color: "var(--color-mono-100)", style: { padding: 4 } })), eventStatus && (_jsxs(EventStatus, __assign({ status: eventStatus }, { children: [eventStatus, " "] })))] })) })), _jsxs(CardContent, { children: [_jsxs("div", { children: [_jsxs(DateContainer, { children: [embargoed && (_jsx(LockTag, { children: _jsx(FontAwesomeIcon, { icon: faLock, height: 16, width: 16 }) })), _jsx(EventDuration, { children: duration })] }), _jsx(Tooltip, __assign({ content: name, childRef: titleRef }, { children: _jsx(EventTitle, { children: _jsx("div", __assign({ ref: titleRef }, { children: _jsx(Highlighter, { value: (nameHighlightingInformation === null || nameHighlightingInformation === void 0 ? void 0 : nameHighlightingInformation.value) || name }) })) }) })), _jsx(Location, { children: location })] }), _jsx("div", { children: organizationName && (_jsxs(Organization, { children: ["By", ' ', _jsx(Highlighter, { value: (organizationNameHighlightingInformation === null || organizationNameHighlightingInformation === void 0 ? void 0 : organizationNameHighlightingInformation.value) ||
                                        organizationName })] })) })] })] }));
};
export default EventCard;
//# sourceMappingURL=EventCard.js.map